export const perPageOptions = [10, 20, 50];
